export const OPTIONS = [
  { text: 'Candidate Name', value: '{candidate}' },
  { text: 'Candidate/Reference Company', value: '{company}' },
  { text: 'Candidate/Reference Relationship', value: '{relationship}' },
  { text: 'My Organization Name', value: '{organization}' }
]

export const INPUT_ID = 'editable-input'
export const MENU_ID = 'editable-input-menu'
export const DELAY = 100
